import intl from "react-intl-universal";
import { http } from './http';
export * from './http';

export const intlGet = (key: string, param = {}) => {
  // console.log('intlGet key', key);
  return key && intl.get(key, param) || key;
}


export const isZH_CN = () => {
  let currentLocale = intl.determineLocale({
    urlLocaleKey: "lang",
    cookieLocaleKey: "lang"
  });
  return currentLocale === 'zh-CN';
}

export const transformToPosts = (data: any) => {
  const { id, title, content, date, modified, categories, excerpt, acf = {} } = data;

  const posts: Post = {
    id,
    title: title.rendered,
    content: content.rendered,
    date,
    modified,
    categories,
    excerpt,
    acf,
  }
  return posts;
}

/**
 * 
 * @param categories 文章分类  未分类 1， 新闻 2， 社招 5 校招 4
 * @param per_page 
 * @param page  从1开始
 */
export const getPosts = (categories: number[], per_page: number, page: number) => {
  const categoriesStr = categories.map(x => `categories[]=${x}`).join('&')
  const url = `/posts?${categoriesStr}&per_page=${per_page}&page=${page}`;
  return new Promise<Post[]>((resolve, reject) => {
    return http.get(url).then((res: any) => {
      console.log('res', res);
      const newPosts = res.map(transformToPosts);
      resolve(newPosts);
    }, err => {
      reject(err);
    })

  })
}

export const postType = {
  uncategorized: 1,
  news_cn: 2,
  news_en: 3,
  club_recruit: 5,
  school_recruit: 4,
  solution_cn: 6,
  solution_en: 7,
}

export const getNewsPostTypeByLang = () => {
  return isZH_CN() ? postType.news_cn : postType.news_en
}

export const getSolutionPostTypeByLang = () => {
  return isZH_CN() ? postType.solution_cn : postType.solution_en
}

export const getSearchParams = () => {
  const search = window.location.search.replace('?', '');
  const paramArr = search.split('&');
  const parsmObj: any = {};
  paramArr.forEach(x => {
    const [key, value] = x.split('=');
    parsmObj[key] = value;
  });
  return parsmObj;
}